module.exports = __webpack_public_path__ + "img/11069871_L.6ee65591.png";